export enum DamagePartsViewEnum {
	List = "list",
	Catalog = "catalog",
}

export enum PartActionEnum {
	Repair = "repair",
	Replace = "replace",
}

export enum PartConfidenceEnum {
	High = "high",
	Low = "low",
}

export interface IDamagePart {
	id: string;
	guidPart: string;
	guidQuoteItem: string;
	name: string;
	categoryName: string;
	subCategoryName: string;
	guidPosition: string;
	position: string;
	idDamageArea: number | null;
	confidence: PartConfidenceEnum;
	isDamaged: boolean;
	action: PartActionEnum | null;
	isFromAi: boolean;
}

export interface IDamagePartsByConfidence {
	high: IDamagePart[];
	low: IDamagePart[];
}

export interface IPartsCatalogFilters {
	searchTerm: string;
	guidPartCategory: string | null;
	guidPartSubCategory: string | null;
	idsDamageArea: number[];
}
